var map = {
	"./icon-ac.svg": "c7ae",
	"./icon-chaleira.svg": "ca31",
	"./icon-coffee.svg": "31a6",
	"./icon-desu.svg": "e620",
	"./icon-dry.svg": "1e89",
	"./icon-eel.svg": "5108",
	"./icon-fotov.svg": "bcd3",
	"./icon-freezer.svg": "5057",
	"./icon-frig-1.svg": "aff6",
	"./icon-frig-2.svg": "f1be",
	"./icon-grill.svg": "bf09",
	"./icon-heat.svg": "f509",
	"./icon-induc.svg": "6f63",
	"./icon-light.svg": "5cfc",
	"./icon-misc.svg": "cf41",
	"./icon-multi.svg": "a2f8",
	"./icon-mw.svg": "0180",
	"./icon-oven.svg": "83c3",
	"./icon-radiator.svg": "c7fc",
	"./icon-robot.svg": "14f0",
	"./icon-termoa.svg": "83cc",
	"./icon-termov.svg": "490e",
	"./icon-toast.svg": "ecf5",
	"./icon-tv.svg": "3d3a",
	"./icon-ve.svg": "020a",
	"./icon-wm-1.svg": "4d10",
	"./icon-wm-2.svg": "2ba4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f24";